import React, {memo} from "react";
// import Swiper core and required components
import SwiperCore, {Navigation, Scrollbar, A11y, Lazy} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';

import {useSelector} from "react-redux";
import {Link, useRouteMatch} from "react-router-dom";

// install Swiper components
SwiperCore.use([Navigation, Scrollbar, A11y, Lazy]);

const SliderCategoriesProducts = () => {
    const {main} = useSelector(state => state.main);
    const match = useRouteMatch();
    const settingSwiper = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        loop: false,
    }
    return (typeof main.products !== "undefined" && Object.keys(main.products).length > 0) ? (
        <div className="base-box-swiper-categories-products">
            <div className={'swiper-cm-categories-products'} dir={'ltr'}>
                <Swiper {...settingSwiper}>
                    {Object.keys(main.products).map((key, index) => <SwiperSlide key={index}>
                        <Link to={`/stores/${match.params.store}/more-products/${key}`}
                              className={'base-link-more-part-swiper-products'}>
                            <div className={'box-txt-item-categories-products'}>
                                <p>{key}</p>
                            </div>
                        </Link>
                    </SwiperSlide>)}
                </Swiper>
            </div>
        </div>
    ) : '';
};

export default memo(SliderCategoriesProducts);
